export const environment = {
    baseUrl: 'https://stage-gramudyamitaweb.lokos.in',
    enableEncryption: false,
    keycloak: {
        clientId: 'web-console',
        issuer: 'https://identity.lokos.in/',
        realm: 'lokos'
    },
    production: false,
    storageSecretKey: '962771dd-7233-48fc-ad80-1a83af19d737',
    subscriptionKey: 'af33e1a7aeaf40b68326f85d7ba85a1f',
    keycloakOcpKey: 'c520712fcd0d4c9ca19955c3052eedd6'
};
